<template>
  <div
    class="relative"
    :class="size === 'responsive' ? 'aspect-square' : 'shrink-0 w-max'"
  >
    <AvatarRoot
      :class="{
        'aspect-square block placeholder': !avatarData.image,
        'w-full h-full @container': size === 'responsive',
      }"
      class="relative"
    >
      <AvatarImage
        :src="avatarData.image ?? ''"
        :class="{
          'size-5': size === '2xs',
          'size-6': size === 'xs',
          'size-7': size === 'sm',
          'size-8': size === 'md' || !size,
          'size-10': size === '2md',
          'size-40': size === 'lg',
          'w-full h-full': size === 'responsive',
          'bg-cover bg-center rounded-full inline-flex justify-center items-stretch object-cover':
            avatarData.image,
          'shadow-[0px_0px_0px_2px_rgba(135,90,249,1.00)] border-2 border-border-dark':
            vipBorder,
        }"
      />
      <AvatarFallback
        :delay-ms="1"
        :class="{
          'capitalize rounded-full inline-flex justify-center items-center': true,
          'size-5 text-xs': size === '2xs' || size === 'xs',
          'size-6 text-xs': size === 'xs',
          'size-7 text-sm': size === 'sm',
          'size-8 text-md': size === 'md' || !size,
          'size-10 text-md': size === '2md',
          'size-40 text-lg': size === 'lg',
          'w-full h-full text-[80cqw]': size === 'responsive',
          'saturate-50': userColor !== undefined,
          'shadow-[0px_0px_0px_2px_rgba(135,90,249,1.00)] border-2 border-border-dark':
            vipBorder,
        }"
        :style="{
          backgroundColor: userColor ?? 'var(--basics-accent-red)',
        }"
      >
        {{ placeholder }}
      </AvatarFallback>
    </AvatarRoot>

    <div v-if="badge" class="absolute -right-3 -bottom-3">
      <PremiumBadge :size="badgeSize" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useUserStore } from "@/stores/user.store";
import { computed } from "vue";
import { AvatarFallback, AvatarImage, AvatarRoot } from "reka-ui";
import PremiumBadge from "@/components/badge/premium-badge.vue";
import { useUserColor } from "@/composables/use-user-color";

const props = defineProps<{
  user?: {
    username?: string;
    avatar?: string | undefined | null;
    id?: string | undefined | null;
  };
  avatar?: {
    name?: string;
    image: string | undefined | null;
    id?: string | undefined | null;
  };
  size?:
    | "2xs"
    | "xs"
    | "sm"
    | "md"
    | "2md"
    | "lg"
    | "xl"
    | "2xl"
    | "responsive";
  defaultColor?: string;
  badge?: boolean;
  badgeSize?: "sm" | "md" | "lg" | "xl";
  vipBorder?: boolean;
}>();

const userStore = useUserStore();

const avatarData = computed(() => {
  return {
    name: props.user?.username ?? props.avatar?.name,
    image: props.user?.avatar ?? props.avatar?.image,
  };
});

const placeholder = computed(() => {
  if (avatarData.value.name) {
    return avatarData.value.name[0];
  }

  return userStore.avatarPlaceholder;
});

const userColor = useUserColor(
  computed(() => props.user?.id ?? props.avatar?.id ?? ""),
);
</script>
